import { WindowLocation } from "@reach/router";
import * as React from "react";

export interface ILocationContext {
    location?: WindowLocation;
}

const LocationContext = React.createContext<ILocationContext>({});
export { LocationContext };
